import React, { useState } from 'react';

const AdminChapter = ({
    onDashboard,
    onCourseManagement,
    onChapterManagement,
    onQuestionBank,
    onStudentDirectory,
    onParentDirectory,
    onRevenue,
    onLogout,
    onBack
}) => {
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
        document.documentElement.classList.toggle('dark');
    };

    return (
        <>
            <style>
                {`
                .material-symbols-outlined {
                    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
                    vertical-align: middle;
                    display: inline-block;
                    line-height: 1;
                    text-transform: none;
                    letter-spacing: normal;
                    word-wrap: normal;
                    white-space: nowrap;
                    direction: ltr;
                }
                ::-webkit-scrollbar {
                    width: 5px;
                }
                ::-webkit-scrollbar-track {
                    background: transparent;
                }
                ::-webkit-scrollbar-thumb {
                    background: rgba(203, 213, 225, 0.5);
                    border-radius: 10px;
                }
                .dark ::-webkit-scrollbar-thumb {
                    background: rgba(51, 65, 85, 0.5);
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: rgba(148, 163, 184, 0.8);
                }
                .dark ::-webkit-scrollbar-thumb:hover {
                    background: rgba(71, 85, 105, 0.8);
                }
                scrollbar-width: thin;
                scrollbar-color: rgba(203, 213, 225, 0.5) transparent;
                `}
            </style>

            <div className={`fixed inset-0 flex overflow-hidden font-sans antialiased ${isDarkMode ? 'dark bg-[#0F172A] text-slate-100' : 'bg-[#F8FAFC] text-slate-900'}`}>
                {/* Mobile Overlay */}
                {isSidebarOpen && (
                    <div 
                        className="fixed inset-0 bg-black/50 z-40 lg:hidden backdrop-blur-sm transition-opacity"
                        onClick={() => setIsSidebarOpen(false)}
                    ></div>
                )}

                {/* Sidebar */}
                <aside className={`w-64 bg-[#131C2E] text-slate-300 flex-shrink-0 flex flex-col border-r border-slate-800 fixed lg:relative z-50 h-full transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full lg:translate-x-0'}`}>
                    <div className="p-6 flex items-center gap-3 shrink-0">
                        <div className="w-10 h-10 bg-[#00A669] rounded-lg flex items-center justify-center text-white font-bold text-xl uppercase tracking-tighter shadow-lg shadow-emerald-500/20">H</div>
                        <div>
                            <h1 className="text-white font-bold leading-tight">Master Admin</h1>
                            <p className="text-[10px] text-slate-500 uppercase tracking-widest font-semibold text-nowrap">System Management</p>
                        </div>
                    </div>

                    <nav className="flex-1 px-4 space-y-1 mt-4 overflow-y-auto custom-scrollbar">
                        <button
                            onClick={onDashboard}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">dashboard</span>
                            <span className="font-medium group-hover:text-white transition-colors">Dashboard Overview</span>
                        </button>

                        <div className="pt-4 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Core Content</div>
                        <button
                            onClick={onCourseManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">auto_stories</span>
                            <span className="font-medium group-hover:text-white transition-colors">Course Management</span>
                        </button>
                        <button className="w-full bg-[#00A669] text-white flex items-center gap-3 px-4 py-3 rounded-xl transition-all shadow-md shadow-emerald-500/20 text-left">
                            <span className="material-symbols-outlined shrink-0 text-xl">account_tree</span>
                            <span className="font-medium">Chapter Management</span>
                        </button>
                        <button
                            onClick={onQuestionBank}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">quiz</span>
                            <span className="font-medium group-hover:text-white transition-colors">Question Bank</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Directories</div>
                        <button
                            onClick={onStudentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">group</span>
                            <span className="font-medium group-hover:text-white transition-colors">Student Directory</span>
                        </button>
                        <button
                            onClick={onParentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">family_restroom</span>
                            <span className="font-medium group-hover:text-white transition-colors">Parent Directory</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Reports</div>
                        <button
                            onClick={onRevenue}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">monitoring</span>
                            <span className="font-medium group-hover:text-white transition-colors">Revenue/Analytics</span>
                        </button>




                    </nav>

                    <div className="p-4 mt-auto border-t border-slate-800 shrink-0">
                        <button
                            onClick={onLogout}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-rose-400 hover:bg-rose-500/10 transition-all group"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl">logout</span>
                            <span className="font-medium group-hover:translate-x-1 transition-transform">Sign Out</span>
                        </button>
                    </div>
                </aside>

                {/* Main Content Area */}
                <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
                    {/* Header */}
                    <header className="h-16 bg-white dark:bg-[#1E293B] border-b border-slate-200 dark:border-slate-800 flex items-center justify-between px-8 sticky top-0 z-20 shrink-0 shadow-sm">
                        <div className="flex-1 max-w-xl flex items-center gap-4">
                            <button 
                                className="lg:hidden text-slate-500 hover:text-[#00A669]"
                                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                            >
                                <span className="material-symbols-outlined">menu</span>
                            </button>
                            <div className="relative flex-1">
                                <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">search</span>
                                <input
                                    className="w-full bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg pl-10 pr-4 py-2 focus:ring-[#00A669] focus:border-[#00A669] transition-all text-sm outline-none text-slate-700 dark:text-slate-200"
                                    placeholder="Search curriculum..."
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="flex items-center gap-6 ml-6">
                            <button className="relative text-slate-500 dark:text-slate-400 hover:text-[#00A669] transition-colors flex items-center">
                                <span className="material-symbols-outlined">notifications</span>
                                <span className="absolute top-0 right-0 w-2 h-2 bg-rose-500 rounded-full border-2 border-white dark:border-[#1E293B]"></span>
                            </button>
                            <div className="h-8 w-[1px] bg-slate-200 dark:bg-slate-700"></div>
                            <div className="flex items-center gap-3">
                                <div className="text-right hidden sm:block">
                                    <p className="text-sm font-semibold dark:text-white">Admin Profile</p>
                                    <p className="text-[10px] text-slate-500 font-bold uppercase tracking-tight">Super Administrator</p>
                                </div>
                                <div className="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 overflow-hidden shadow-sm">
                                    <img alt="Admin Avatar" className="w-full h-full object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuB_RLrWS6EwBazBnSQG5_DHFfXALJfYg9wsfMW2fPBEUgyM8X72ZCm3tlqpialTVYycHghgR294Gsrna7Md-Y9BvMy9mxyIOvqFuj8_YHzdBVxVI2U40W2yQq21BtKRTS6sIsuf-Yp954VMbmBsiyidj0IifV9SqpurFlj0TzEkyVoievlPd5qy98srI15ENSq6h760WxEMEp8ZODu-efso3LH0phGIQADhqq71tFNmvHA8-ImYHsI7eorpZHeD2nlfdjDp1fPs5MM" />
                                </div>
                            </div>
                        </div>
                    </header>

                    {/* Scrollable Content */}
                    <main className="flex-1 overflow-y-auto p-8 space-y-8 bg-background-light dark:bg-[#0F172A] pb-24">
                        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                            <div>
                                <h2 className="text-2xl font-bold tracking-tight dark:text-white leading-tight">Chapter Management</h2>
                                <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Organize and structure the curriculum hierarchy for selected courses.</p>
                            </div>
                            <button className="px-5 py-2.5 rounded-lg bg-[#00A669] text-white font-semibold text-sm hover:bg-opacity-90 shadow-lg shadow-emerald-500/20 transition-all flex items-center gap-2">
                                <span className="material-symbols-outlined text-[20px]">add_circle</span>
                                Add New Chapter
                            </button>
                        </div>

                        {/* Course Selector */}
                        <div className="bg-white dark:bg-[#1E293B] p-4 rounded-xl border border-slate-200 dark:border-slate-800 flex flex-wrap items-center gap-4 shadow-sm">
                            <div className="flex items-center gap-3 flex-1 min-w-[240px]">
                                <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">Active Course:</span>
                                <select className="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg py-1.5 px-3 text-sm font-medium focus:ring-[#00A669] focus:border-[#00A669] outline-none dark:text-white">
                                    <option>Advanced Mathematics Grade 12</option>
                                    <option>Quantum Physics Basics</option>
                                    <option>Organic Chemistry Overview</option>
                                </select>
                            </div>
                            <div className="flex items-center gap-2 text-[10px] font-bold text-slate-400 bg-slate-100 dark:bg-slate-800 px-3 py-1.5 rounded-lg uppercase tracking-wider">
                                <span className="material-symbols-outlined text-sm">info</span>
                                Total: 08 Chapters • 32 Topics
                            </div>
                        </div>

                        {/* Chapter List */}
                        <div className="space-y-4">
                            {[
                                {
                                    id: 1,
                                    title: 'Introduction to Complex Numbers',
                                    topics: [
                                        { id: '1.1', title: 'Defining Imaginary Units', tag: 'Video • 12m' },
                                        { id: '1.2', title: 'Argand Diagrams and Visual Representation', tag: 'Quiz • 5 Questions' }
                                    ]
                                },
                                {
                                    id: 2,
                                    title: 'Polar Coordinates & De Moivre\'s Theorem',
                                    topics: [
                                        { id: '2.1', title: 'Converting Rectangular to Polar Forms', tag: 'PDF • 4.5 MB' },
                                        { id: '2.2', title: 'Application of De Moivre\'s Theorem', tag: 'Video • 24m' }
                                    ]
                                }
                            ].map((chapter) => (
                                <div key={chapter.id} className="bg-white dark:bg-[#1E293B] rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden group">
                                    <div className="p-4 bg-slate-50/50 dark:bg-slate-800/30 flex items-center justify-between border-b border-slate-100 dark:border-slate-800">
                                        <div className="flex items-center gap-4">
                                            <span className="material-symbols-outlined cursor-grab active:cursor-grabbing text-slate-300 hover:text-slate-500 transition-colors">drag_indicator</span>
                                            <div className="flex items-center gap-3">
                                                <div className="w-8 h-8 rounded-lg bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 flex items-center justify-center font-bold text-slate-600 dark:text-slate-300 text-sm shadow-sm">{chapter.id}</div>
                                                <h3 className="text-base font-bold text-slate-900 dark:text-white">{chapter.title}</h3>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <button className="p-2 text-slate-400 hover:text-[#00A669] transition-colors">
                                                <span className="material-symbols-outlined text-[20px]">edit</span>
                                            </button>
                                            <button className="px-3 py-1.5 text-[10px] font-bold text-[#00A669] hover:bg-[#00A669]/10 rounded-lg transition-all flex items-center gap-1 uppercase tracking-widest">
                                                <span className="material-symbols-outlined text-sm">add</span>
                                                Add Topic
                                            </button>
                                        </div>
                                    </div>
                                    <div className="p-2 space-y-1">
                                        {chapter.topics.map((topic) => (
                                            <div key={topic.id} className="flex items-center justify-between p-3 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800/50 group/item transition-colors">
                                                <div className="flex items-center gap-3 pl-10">
                                                    <span className="material-symbols-outlined text-slate-300 text-sm opacity-0 group-hover/item:opacity-100 transition-all">drag_indicator</span>
                                                    <span className="text-sm font-medium text-slate-600 dark:text-slate-300">{topic.id} {topic.title}</span>
                                                </div>
                                                <div className="flex items-center gap-4 opacity-0 group-hover/item:opacity-100 transition-all">
                                                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-tighter bg-slate-100 dark:bg-slate-800 px-2 py-0.5 rounded">{topic.tag}</span>
                                                    <button className="text-slate-400 hover:text-[#00A669] transition-colors">
                                                        <span className="material-symbols-outlined text-[18px]">edit</span>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}

                            {/* Expandable Placeholder */}
                            <div className="bg-white dark:bg-[#1E293B] rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden group">
                                <div className="p-4 bg-slate-50/50 dark:bg-slate-800/30 flex items-center justify-between transition-colors">
                                    <div className="flex items-center gap-4">
                                        <span className="material-symbols-outlined text-slate-300">drag_indicator</span>
                                        <div className="flex items-center gap-3">
                                            <div className="w-8 h-8 rounded-lg bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 flex items-center justify-center font-bold text-slate-600 dark:text-slate-300 text-sm">3</div>
                                            <h3 className="text-base font-bold text-slate-900 dark:text-white">Loci in the Complex Plane</h3>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mr-2">4 Topics</span>
                                        <button className="p-2 text-slate-400 hover:text-[#00A669] transition-colors">
                                            <span className="material-symbols-outlined text-[20px]">expand_more</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <footer className="py-8 border-t border-slate-200 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between text-slate-400 text-[10px] font-bold uppercase tracking-widest gap-4">
                            <div className="flex items-center gap-2">
                                <div className="w-6 h-6 bg-[#00A669] rounded flex items-center justify-center text-white text-[10px] font-bold">H</div>
                                <span>© 2024 Himigo Platform - Master Admin Console</span>
                            </div>
                        </footer>
                    </main>
                </div>

                {/* Dark Mode Toggle Float */}
                <button
                    onClick={toggleDarkMode}
                    className="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-700 shadow-xl shadow-slate-200/50 dark:shadow-none flex items-center justify-center text-slate-600 dark:text-slate-300 z-[60] hover:scale-110 active:scale-95 transition-all"
                >
                    <span className="material-symbols-outlined">{isDarkMode ? 'light_mode' : 'dark_mode'}</span>
                </button>
            </div>
        </>
    );
};

export default AdminChapter;
